export function extractRoundNumber(line) {
  const roundMatch = line?.match(/R(\d+):|Round (\d+):/);
  return roundMatch ? parseInt(roundMatch[1] || roundMatch[2], 10) : null;
}

export function classifyBattleLine(line = "") {
  const lower = line.toLowerCase();
  if (line.startsWith("🐾")) return { kind: "beast", label: "Beast" };
  if (line.startsWith("🏆")) return { kind: "victory", label: "Victory" };
  if (lower.includes("finishing blow") || lower.includes("fight-ending blow") || lower.includes("deciding strike") || lower.includes("coup de grâce")) {
    return { kind: "finisher", label: "Finisher" };
  }
  if (lower.includes("bloodied") || lower.includes("death's door") || lower.includes("end is near") || lower.includes("moments from defeat") || lower.includes("mortal danger")) {
    return { kind: "bloodied", label: "Danger" };
  }
  if (lower.includes("critical")) return { kind: "critical", label: "Critical" };
  if (lower.includes("slips clear") || lower.includes("cuts only air") || lower.includes("whistle past") || lower.includes("evades")) {
    return { kind: "miss", label: "Miss" };
  }
  if (lower.includes("turns it aside") || lower.includes("parries") || lower.includes("glancing") || lower.includes("shrugs it off") || lower.includes("deflects")) {
    return { kind: "block", label: "Guard" };
  }
  if (lower.includes("riposte") || lower.includes("shield bash") || lower.includes("stunned") || lower.includes("tangled") || lower.includes("net")) {
    return { kind: "control", label: "Control" };
  }
  if (line.startsWith("⚔") || line.startsWith("🗣️") || lower.includes("tactical edge")) {
    return { kind: "intro", label: "Arena" };
  }
  return { kind: "exchange", label: "Exchange" };
}

export function highlightCombatText(text = "") {
  const keywords = [
    "CRITICAL", "FINISHING BLOW", "FIGHT-ENDING", "MOMENTUM", "STUNNED", "RIPOSTE",
    "SECOND WIND", "TACTICAL EDGE", "BLOODIED", "VICTORY", "COMEBACK",
  ];
  let result = text;
  keywords.forEach((keyword) => {
    const regex = new RegExp(`\\b${keyword}\\b`, "gi");
    result = result.replace(regex, (match) => `<strong class="text-amber-200 font-semibold">${match}</strong>`);
  });
  return result;
}

export function linePlaybackFactor(line = "") {
  const { kind } = classifyBattleLine(line);
  if (kind === "finisher" || kind === "victory") return 1.55;
  if (kind === "critical" || kind === "bloodied") return 1.25;
  if (kind === "intro") return 1.15;
  return 1;
}

export function battleLineClasses(kind) {
  switch (kind) {
    case "victory":
      return "border-amber-500/60 bg-amber-950/30 text-amber-200";
    case "finisher":
      return "border-red-700/60 bg-red-950/30 text-red-200";
    case "bloodied":
      return "border-rose-700/60 bg-rose-950/30 text-rose-100";
    case "critical":
      return "border-red-800/60 bg-red-950/20 text-red-300";
    case "beast":
      return "border-emerald-800/50 bg-emerald-950/20 text-emerald-100";
    case "miss":
      return "border-emerald-800/50 bg-emerald-950/20 text-emerald-200";
    case "block":
      return "border-cyan-800/50 bg-cyan-950/20 text-cyan-200";
    case "control":
      return "border-violet-800/50 bg-violet-950/20 text-violet-200";
    case "intro":
      return "border-amber-900/40 bg-zinc-950/80 text-zinc-300";
    default:
      return "border-zinc-800 bg-zinc-950/60 text-zinc-300";
  }
}